import React, { useMemo } from "react";
import PropTypes from "prop-types";
import indicatorRegistry from "../../../Registry/Indicators/IndicatorRegistry";

// using copilot-instructions: Render the correct Stockcharts series for the indicator, using config and appearanceConfig.
const IndicatorRenderer = ({
  indicator,
  onContextMenu,
  onHover,
  onUnHover,
  chartType,
}) => {
  // Find the registry entry for this indicator
  const registryEntry = useMemo(() => {
    if (!indicator || !indicator.key) {
      return null;
    }
    for (const categoryKey of Object.keys(indicatorRegistry)) {
      const entry = indicatorRegistry[categoryKey].indicators[indicator.key];
      if (entry) return entry;
    }
    return null;
  }, [indicator]);

  // Early returns with minimal logging
  if (!registryEntry) {
    return null;
  }

  // Get the Stockcharts series component
  const SeriesComponent = registryEntry.series;
  if (!SeriesComponent) {
    return null;
  }

  // Clone appearance props to avoid mutations
  const appearanceProps = { ...indicator.appearanceConfig };

  // Apply transformation if defined in registry
  const finalAppearanceProps = registryEntry.transformAppearanceConfig
    ? registryEntry.transformAppearanceConfig(appearanceProps)
    : appearanceProps;

  // Ensure yAccessor is properly set
  if (!finalAppearanceProps.yAccessor && indicator.renderKey) {
    finalAppearanceProps.yAccessor = (d) => d[indicator.renderKey];
  }

  // Merge config values (for indicators that need them like RSI)
  const finalProps = {
    ...finalAppearanceProps,
    ...indicator.config,
    chartType,
  };

  return (
    <SeriesComponent
      {...finalProps}
      onContextMenu={onContextMenu}
      onHover={onHover}
      onUnHover={onUnHover}
    />
  );
};

IndicatorRenderer.propTypes = {
  indicator: PropTypes.object.isRequired,
  onContextMenu: PropTypes.func,
  onHover: PropTypes.func,
  onUnHover: PropTypes.func,
  chartType: PropTypes.string,
};

export default IndicatorRenderer;
